import { useEffect, useState } from 'react'
import { supabase } from '@/lib/supabase'
import { useOrg } from '@/context/OrgContext'
import type { Produk, ProdukTipe } from '@/types'

export function useProducts(tipeFilter?: ProdukTipe) {
  const { orgId, loading: orgLoading } = useOrg()
  const [products, setProducts] = useState<Produk[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (orgLoading) return

    setLoading(true)

    async function fetch() {
      let query = supabase
        .from('produk')
        .select('id, deskripsi, harga, harga_max, tipe, stok, sewa_per_hari, gambar_url, aktif, category_id, satuan_id, master_item_id, created_at')
        .eq('aktif', true)
        .order('created_at', { ascending: false })

      if (orgId) query = query.eq('organization_id', orgId)
      if (tipeFilter) query = query.eq('tipe', tipeFilter)

      const { data: produkData, error } = await query

      if (error) {
        console.error('useProducts produk error:', error)
        setLoading(false)
        return
      }

      const data = produkData ?? []
      if (data.length === 0) { setProducts([]); setLoading(false); return }

      const masterIds = [...new Set(data.map(p => p.master_item_id).filter(Boolean))]
      const satuanIds = [...new Set(data.map(p => p.satuan_id).filter(Boolean))]

      const [{ data: masters }, { data: satuans }] = await Promise.all([
        supabase.from('master_item').select('id, nama_item').in('id', masterIds),
        supabase.from('satuan').select('id, nama').in('id', satuanIds),
      ])

      const masterMap: Record<string, string> = {}
      for (const m of masters ?? []) masterMap[m.id] = m.nama_item

      const satuanMap: Record<string, string> = {}
      for (const s of satuans ?? []) satuanMap[s.id] = s.nama

      const normalized: Produk[] = data.map(p => ({
        ...p,
        nama: masterMap[p.master_item_id] || '',
        satuan: satuanMap[p.satuan_id] || 'unit',
      }))

      setProducts(normalized)
      setLoading(false)
    }

    fetch()
  }, [orgId, orgLoading, tipeFilter])

  return { products, loading }
}
